<script>
    import options from './SiteNavigationOverlay.options'
    export default options
</script>

<template>
    <transition name="nlx-overlay__fade">
        <div class="nlx-overlay" v-if="showOverlay"></div>
    </transition> 
</template>
